<template>
  <el-button class="mobile-app-menu-trigger" text aria-label="全部应用" @click="visible = true"><el-icon><Grid /></el-icon><span>应用</span></el-button>
  <el-drawer v-model="visible" title="全部应用" direction="btt" size="min(80dvh, 620px)" class="mobile-app-menu" :append-to-body="true">
    <nav class="mobile-app-menu__items" aria-label="全部业务模块">
      <RouterLink v-for="item in items" :key="item.path" :to="item.path" @click="visible = false"><el-icon><component :is="item.icon" /></el-icon><span>{{ item.label }}</span></RouterLink>
    </nav>
  </el-drawer>
</template>
<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { Grid, Collection } from "@element-plus/icons-vue";
import { RouterLink, useRoute } from "vue-router";
import { useNavigationItems } from "@/composables/useNavigationItems";
import { useMobileLayout } from "@/composables/useMobileLayout";
const visible = ref(false);
const route = useRoute();
const navigationItems = useNavigationItems();
const items = computed(() => [...navigationItems.value, { path: "/matters", label: "专题与关系", icon: Collection }]);
const { isMobile } = useMobileLayout();
watch(() => route.fullPath, () => { visible.value = false; });
watch(isMobile, (mobile) => { if (!mobile) visible.value = false; });
</script>
<style scoped>
.mobile-app-menu-trigger { display: none; }
.mobile-app-menu__items { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.mobile-app-menu__items a { display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 10px; min-height: 86px; padding: 12px 6px; border: 1px solid var(--line); border-radius: var(--r-md); color: var(--ink); font-size: 13px; text-align: center; }
.mobile-app-menu__items a.router-link-active { border-color: var(--brand); background: var(--brand-softer); color: var(--brand); }
.mobile-app-menu__items .el-icon { font-size: 22px; color: var(--brand); }
@media (max-width: 960px) { .mobile-app-menu-trigger { display: inline-flex; min-height: 44px; padding: 0 8px; margin: 0; color: #fff; } }
</style>
